import { FaRegFilePdf } from "react-icons/fa"
import { HiOutlinePhotograph } from "react-icons/hi"
import useQueryDowload from "../../customHooks/useQueryDowloand"
import { useAppSelector } from "../../store/hooks"

interface CodeqrProps {
    svg: string
    black_white: boolean,
    id_campaign: string
  }
const Codeqrgenerate = ({svg,black_white, id_campaign}:CodeqrProps) => {
    const { name} = useAppSelector(state => state.user)
    const {brand} = useAppSelector(state => state.campaign.detail)

    let namepdf = black_white ? `qr-code-cut-outs-black&white-${name}-${brand}` : `qr-code-cut-outs-${name}-${brand}`
    let nameimg = black_white ? `qr-code-black&white-${name}-${brand}` : `qr-code-${name}-${brand}`

    const { isLoading, onGenerate } = useQueryDowload({ name: `${namepdf.toUpperCase()}.pdf` })
    const { isLoading:isLoadingImg, onGenerate:onGenerateImg } = useQueryDowload({ name: `${nameimg.toUpperCase()}.png` })


    const onDownloadPdf = () => {
        onGenerate({
          url: black_white ? '/api/purls/employee/campaigns/pdf/en/one-bw' : '/api/purls/employee/campaigns/pdf/en/one',
          params: {
            id_campaign
          }
        })
    }
    const onDownloadImg = () => {
        onGenerateImg({
          url: black_white ? '/api/purls/employee/campaigns/png/en/one-bw' : '/api/purls/employee/campaigns/png/en/one',
          params: {
            id_campaign
          }
        })
    }

    return (
        <div className="c-code-qr__container">
        <div className="c-code-qr__header">
            <span className="c-code-qr__title">{black_white ? `Black & White QR Code` :`Color QR Code`}</span>
        </div>
        <div className="c-code-qr__content" >
            <img src={svg} className={`c-code-qr__img-qr ${black_white && `c-code-qr__img-bw`}`} alt="qr-campaign"/>
        </div>
        <button className={`c-code-qr__button-download ${isLoadingImg && `c-code-qr__button-download--disabled`}`} onClick={onDownloadImg}>
            {
            isLoadingImg ?
            <>
                Download...<div className="spiner"></div>
            </>
            :
            <>
                Download QR Code <HiOutlinePhotograph />
            </>
            }
        </button>
        <button className={`c-code-qr__button-download ${isLoading && `c-code-qr__button-download--disabled`}`} onClick={onDownloadPdf}>
            {
            isLoading ?
                <>
                Download...<div className="spiner"></div>
                </>
                :
                <>
                {black_white ? `Download Black & White QR Code Cut outs` : `Dowload Color QR Code Cut outs`}
                <FaRegFilePdf />
                </>
            }
            </button>
        </div>
    )
}

export default Codeqrgenerate

